import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthModal from './AuthModal';

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, isAuthChecking } = useAuth();
  const navigate = useNavigate();

  // Show nothing while checking memory to prevent flickering
  if (isAuthChecking) return null; 

  // If they are not logged in, show the modal. 
  // If they click 'X', kick them back to the home page!
  if (!isLoggedIn) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
        <AuthModal 
          isOpen={true} 
          onClose={() => navigate('/')} // 👈 The mandatory redirect
        />
      </div>
    );
  }

  // If they ARE logged in, let them see the page!
  return children;
};

export default ProtectedRoute;